<template>
  <!-- 新增门点弹框  -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="siteInfo.title"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="100px" label-position="left">
        <el-form-item :label="$t('Partners.doorName')">
          <el-input v-model="siteInfo.name" no="name" />
        </el-form-item>
        <el-form-item :label="$t('Payment.contactPerson')">
          <el-input v-model="siteInfo.contact" no="contact" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')">
          <el-input v-model="siteInfo.phone" no="phone" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.DoorAddress')">
          <el-input v-model="siteInfo.address" no="address" />
        </el-form-item>
        <el-form-item :label="$t('Payment.remarks')">
          <el-input v-model="siteInfo.remarks" no="remarks" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
          <cargo-advance-select
            no="city"
            :cache="false"
            filterable
            :default-value="siteInfo.city"
            :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
            :tag-value="'code'"
            :placeholder="' '"
            :static-options="cityList"
            @parentCallBack="p=>{siteInfo.city=p.value}"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { saveDoorSite } from '@/api/partner/site'
import { getLocationList } from '@/api/location'

export default {
  name: 'AddDoorDialog',
  components: {
    CargoAdvanceSelect,
    cargoUserSelect,
    cargoDepartmentSelect
  },
  props: {
    visible: { type: Boolean, required: true },
    site: { type: Object, required: false }
  },
  data() {
    return {
      siteInfo: {},
      innerVisible: false,
      cityList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      this.siteInfo = this.site
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.closeHandler()
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.siteInfo = this.site
      this.innerVisible = true
    }
    this.cityList = await getLocationList({}).then((res) => {
      return res.data.list || []
    })
  },
  methods: {
    closeHandler() {
      this.innerVisible = false
    },
    saveSub() {
      const self = this
      const form = self.siteInfo
      console.log('form', form)
      for (const key in form) {
        form[key] = form[key].trim() // 去掉前后空格
      }
      if (!form.name && !form.address && !form.contact && !form.phone && !form.city) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseInputOneDoorInfoAtLeast'))
        return
      }
      form.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      console.log('form', form)
      saveDoorSite(form).then(res => {
        if (!res.data) {
          self.$message.error(self.$t('CargoMsg.Cargo_ExistDoorSite'))
        } else {
          self.innerVisible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }
      }).catch(() => {
        self.innerVisible = false
      }).finally(() => loading.close())
    }
  }
}
</script>
